import Head from "next/head";
import { FunctionComponent } from "react";
import { Thing, WithContext } from "schema-dts";

interface Props {
  schema: WithContext<Thing> | WithContext<Thing>[];
}

const SEOSchema: FunctionComponent<Props> = ({ schema }) => {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
};

export default SEOSchema;
